$shm_hitalama_map_widget_float_component $shm_hitalama_map_widget_float_code
